export const GroupFilterElements = [
  {
    id: "0001",
    isMain: true,
    isShow: false,
    type: "multiDatePicker",
    valueName: "creditValidFrom",
    valueName2:"creditValidTo",
    label: "از ماه",
    label2:"تا ماه",
    WrapperClassName: "!filterInput",
    onlyMonthPicker:true
  },

  {
    id: "0002",
    isMain: true,
    isShow: false,
    type: "inputSelect",
    valueName: "settlementStatus",
    label: "وضعیت پرداخت",
    options: "statusOptions",
    WrapperClassName: "!filterInput",
    onlyMonthPicker:true
  },

];
